import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { ArrowRightIcon, StarIcon, TagIcon, BeakerIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
// Product data
const products = [{
  id: 'microbiota-reset-protocol',
  name: 'Microbiota Reset Protocol',
  tagline: 'Reset Your Gut. Reset Your Health.',
  description: 'A science-backed program designed to restore microbial balance, disrupt harmful biofilms, and strengthen your gut barrier.',
  image: 'https://images.unsplash.com/photo-1530026186672-2cd00ffc50fe?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  featured: true,
  price: '$129.99',
  tags: ['30-day program', 'Biofilm disruptor', 'Gut restoration']
}, {
  id: 'daily-probiotic-complex',
  name: 'Daily Probiotic Complex',
  tagline: 'Clinically-Validated Strains',
  description: 'Evidence-based probiotic blend featuring 12 research-backed strains for daily microbiome maintenance.',
  image: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  featured: false,
  price: '$49.99',
  tags: ['Daily use', '50 billion CFU', 'Delayed-release']
}, {
  id: 'gut-barrier-support',
  name: 'Gut Barrier Support Formula',
  tagline: 'Strengthen Your Intestinal Lining',
  description: 'Specialized blend of L-glutamine, zinc carnosine, and botanicals to support gut barrier integrity.',
  image: 'https://images.unsplash.com/photo-1471864190281-a93a3070b6de?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  featured: false,
  price: '$59.99',
  tags: ['Leaky gut support', 'Anti-inflammatory', 'Gut repair']
}, {
  id: 'microbiome-testing-kit',
  name: 'Microbiome Analysis Kit',
  tagline: 'Know Your Gut. Personalize Your Protocol.',
  description: 'Comprehensive at-home testing kit with detailed analysis of your gut microbiome composition and personalized recommendations.',
  image: 'https://images.unsplash.com/photo-1579154341098-e4e158cc7f55?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  featured: false,
  price: '$199.99',
  tags: ['At-home testing', 'Detailed report', 'Personalized plan']
}, {
  id: 'digestive-enzyme-blend',
  name: 'Digestive Enzyme Blend',
  tagline: 'Optimize Nutrient Absorption',
  description: 'Full-spectrum enzyme formula to support digestion of proteins, fats, carbohydrates, and fiber.',
  image: 'https://images.unsplash.com/photo-1563203369-26f2e4a5ccf7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  featured: false,
  price: '$39.99',
  tags: ['Digestive support', 'Meal companion', 'Bloating relief']
}, {
  id: 'prebiotic-fiber-supplement',
  name: 'Prebiotic Fiber Complex',
  tagline: 'Feed Your Beneficial Bacteria',
  description: 'Diverse blend of soluble fibers designed to nourish beneficial gut bacteria and support microbiome diversity.',
  image: 'https://images.unsplash.com/photo-1595390282366-f5e8a4e9abf9?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  featured: false,
  price: '$34.99',
  tags: ['Microbiome diversity', 'Gentle formula', 'Daily support']
}];
const ProductsPage = () => {
  // Featured product is the first one (Microbiota Reset Protocol)
  const featuredProduct = products[0];
  // Other products
  const otherProducts = products.slice(1);
  return <div className="min-h-screen bg-white" data-id="element-612" data-mp="2h9bim4qpor3v">
      <Navbar data-id="element-613" data-mp="2hacto97q9dll" />
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-teal-900 to-teal-800 text-white" data-id="element-614" data-mp="2h7i98hoprss6">
        <div className="absolute inset-0 overflow-hidden" data-id="element-615" data-mp="2v2t1rofhk1td">
          <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1530026186672-2cd00ffc50fe?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80')] bg-cover bg-center opacity-20" data-id="element-616" data-mp="2q8ylkuz3a4z1"></div>
        </div>
        <div className="relative container mx-auto px-4 py-24 max-w-7xl" data-id="element-617" data-mp="1xkkmsd06f4mf">
          <div className="max-w-3xl" data-id="element-618" data-mp="2b8ufaqs3v4uh">
            <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-619" data-mp="2b9w3lwy4tnu5">
              Science-Backed Microbiome Products
            </h1>
            <p className="text-xl mb-8 text-teal-100" data-id="element-620" data-mp="2l68wislurxnu">
              Discover our research-validated formulas designed to optimize gut
              health and overall wellness.
            </p>
            <div className="flex flex-wrap gap-4" data-id="element-621" data-mp="2pys5fc9li4mb">
              <button className="bg-white text-teal-800 hover:bg-teal-50 transition-colors duration-300 px-6 py-3 rounded-md font-medium flex items-center" data-id="element-622" data-mp="2txr8ssfohtbn">
                Shop All Products <ArrowRightIcon className="ml-2" size={18} data-id="element-623" data-mp="33w6z4t6vsyk3" />
              </button>
              <button className="bg-transparent border border-white text-white hover:bg-white/10 transition-colors duration-300 px-6 py-3 rounded-md font-medium flex items-center" data-id="element-624" data-mp="38vjoplp50jqd">
                Our Research <BeakerIcon className="ml-2" size={18} data-id="element-625" data-mp="1ehsdwiv2nttc" />
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Featured Product Section */}
      <div className="py-16 bg-white" data-id="element-626" data-mp="3ru6fje53bedp">
        <div className="container mx-auto px-4 max-w-7xl" data-id="element-627" data-mp="3n0toyyguoxib">
          <div className="flex justify-center mb-12" data-id="element-628" data-mp="3mz8vzda6pmmk">
            <div className="inline-block px-4 py-1 bg-teal-100 text-teal-800 rounded-full text-sm font-medium" data-id="element-629" data-mp="3j0tdnmp1t2fh">
              Featured Product
            </div>
          </div>
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-630" data-mp="ela4anu8wnev">
            <div className="rounded-xl overflow-hidden shadow-lg" data-id="element-631" data-mp="ejfn9km3hfg2">
              <img src={featuredProduct.image} alt={featuredProduct.name} className="w-full h-96 object-cover" data-id="element-632" data-mp="al9kenodnk0f" />
            </div>
            <div data-id="element-633" data-mp="kz8d6e2wimu">
              <h2 className="text-3xl font-bold mb-3 text-teal-800" data-id="element-634" data-mp="lirgqfgtd2g">
                {featuredProduct.name}
              </h2>
              <p className="text-xl text-gray-700 mb-4" data-id="element-635" data-mp="2q8q889vrqdtn">
                {featuredProduct.tagline}
              </p>
              <p className="text-gray-600 mb-6" data-id="element-636" data-mp="2mtewso0upjw2">
                {featuredProduct.description}
              </p>
              <div className="flex flex-wrap gap-2 mb-6" data-id="element-637" data-mp="2rsi1u8gtzq41">
                {featuredProduct.tags.map((tag, index) => <span key={index} className="inline-flex items-center px-3 py-1 bg-teal-50 text-teal-700 rounded-full text-sm" data-id="element-638" data-mp="2drp31bjhy8v4" data-mpi={index}>
                    <TagIcon size={14} className="mr-1" data-id="element-639" data-mp="241mcdhzul6zy" /> {tag}
                  </span>)}
              </div>
              <p className="text-2xl font-bold text-teal-800 mb-6" data-id="element-640" data-mp="28uoxr2uh1a52">
                {featuredProduct.price}
              </p>
              <div className="flex flex-wrap gap-4" data-id="element-641" data-mp="1v062rcgux8ws">
                <Link to={`/products/${featuredProduct.id}`} className="bg-teal-800 text-white hover:bg-teal-700 transition-colors duration-300 px-6 py-3 rounded-md font-medium flex items-center" data-id="element-642" data-mp="1z4dt1e2yqwx4">
                  View Product <ArrowRightIcon className="ml-2" size={18} data-id="element-643" data-mp="16guj6o23s8pf" />
                </Link>
                <button className="bg-white border border-teal-800 text-teal-800 hover:bg-teal-50 transition-colors duration-300 px-6 py-3 rounded-md font-medium" data-id="element-644" data-mp="11i17902gsprd">
                  Add to Cart
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Our Products Section */}
      <div className="py-16 bg-gray-50" data-id="element-645" data-mp="1pf6wmm01s4qt">
        <div className="container mx-auto px-4 max-w-7xl" data-id="element-646" data-mp="1pe5lyimy1k9m">
          <h2 className="text-3xl font-bold mb-12 text-center text-teal-800" data-id="element-647" data-mp="1khnh7irm5lxa">
            Our Products
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-648" data-mp="1z4gpw56mntgi">
            {otherProducts.map(product => <div key={product.id} className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300" data-id="element-649" data-mp="1u7grmgg0ruzy">
                <div className="h-48 overflow-hidden" data-id="element-650" data-mp="246ft9f2daqdg">
                  <img src={product.image} alt={product.name} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" data-id="element-651" data-mp="3akc5izu2dh9f" />
                </div>
                <div className="p-6" data-id="element-652" data-mp="3kirvv0l9omhv">
                  <h3 className="text-xl font-bold mb-2 text-teal-800" data-id="element-653" data-mp="3ojbts6dnzu52">
                    {product.name}
                  </h3>
                  <p className="text-sm text-gray-500 mb-3" data-id="element-654" data-mp="2rudymn205u7d">
                    {product.tagline}
                  </p>
                  <p className="text-gray-600 mb-4 text-sm line-clamp-2" data-id="element-655" data-mp="2wsxp90rjju62">
                    {product.description}
                  </p>
                  <div className="flex flex-wrap gap-2 mb-4" data-id="element-656" data-mp="35kpvt0dg2j5d">
                    {product.tags.slice(0, 2).map((tag, index) => <span key={index} className="inline-flex items-center px-2 py-1 bg-teal-50 text-teal-700 rounded-full text-xs" data-id="element-657" data-mp="291s88i9v6vu6" data-mpi={index}>
                        {tag}
                      </span>)}
                  </div>
                  <div className="flex justify-between items-center" data-id="element-658" data-mp="20n4cojfgn8xp">
                    <p className="text-lg font-bold text-teal-800" data-id="element-659" data-mp="1wjptjjw86cg1">
                      {product.price}
                    </p>
                    <Link to={`/products/${product.id}`} className="text-teal-600 hover:text-teal-800 font-medium flex items-center text-sm" data-id="element-660" data-mp="1rkcy4arafx1u">
                      View Details <ArrowRightIcon className="ml-1" size={16} data-id="element-661" data-mp="1hu0fio31adyc" />
                    </Link>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
      {/* Why CalBiome Products Section */}
      <div className="py-16 bg-white" data-id="element-662" data-mp="13vtp1t0ezg8p">
        <div className="container mx-auto px-4 max-w-7xl" data-id="element-663" data-mp="13usc1izu8joc">
          <h2 className="text-3xl font-bold mb-12 text-center text-teal-800" data-id="element-664" data-mp="yw7a9f4xtrxs">
            <span className="text-teal-600" data-id="element-665" data-mp="evfhp0ialcyj">✅</span> Why Choose CalBiome
            Products?
          </h2>
          <div className="grid md:grid-cols-4 gap-6" data-id="element-666" data-mp="aulte60xtw54">
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-667" data-mp="atu0j2yq6cij">
              <div className="text-teal-600 mb-4" data-id="element-668" data-mp="olqmsqdpps70">
                <BeakerIcon size={32} data-id="element-669" data-mp="onlb8eo702fu" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-teal-800" data-id="element-670" data-mp="jnffonesxvsh">
                Research-Backed
              </h3>
              <p className="text-gray-700" data-id="element-671" data-mp="3s2pixyufh71u">
                All formulations are based on peer-reviewed research at CalMiR.
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-672" data-mp="5viqar4ipzzs">
              <div className="text-teal-600 mb-4" data-id="element-673" data-mp="5swh6n1zbcfg">
                <StarIcon size={32} data-id="element-674" data-mp="uuyi38gtf4i" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-teal-800" data-id="element-675" data-mp="y8yx5xkje9b">
                Ukweli Certified™
              </h3>
              <p className="text-gray-700" data-id="element-676" data-mp="1cbkxp2eh16om">
                Independently tested and validated for purity and potency.
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-677" data-mp="2u7d8y1p0sinm">
              <div className="text-teal-600 mb-4" data-id="element-678" data-mp="2z818xcv889tz">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-679" data-mp="2z5oiebbekr5b">
                  <path d="M9 12h.01" data-id="element-680" data-mp="3hxr3byv2utld"></path>
                  <path d="M15 12h.01" data-id="element-681" data-mp="346vswi4xk4fo"></path>
                  <path d="M10 16c.5.3 1.2.5 2 .5s1.5-.2 2-.5" data-id="element-682" data-mp="3462ss00h8d6i"></path>
                  <path d="M19 6.3a9 9 0 0 1 1.8 3.9 2 2 0 0 1 0 3.6 9 9 0 0 1-17.6 0 2 2 0 0 1 0-3.6A9 9 0 0 1 5 6.3" data-id="element-683" data-mp="395fay7gekw2r"></path>
                  <path d="M3 6.3a9 9 0 0 1 4.9-4 1 1 0 0 1 .9.1 1 1 0 0 0 1.4-.1 1 1 0 0 1 .9-.1 9 9 0 0 1 4.9 4" data-id="element-684" data-mp="pdj455lkncm"></path>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-3 text-teal-800" data-id="element-685" data-mp="fckkpk9708yu">
                Bioavailable
              </h3>
              <p className="text-gray-700" data-id="element-686" data-mp="adhq6tqu9l54">
                Formulated for optimal absorption and effectiveness.
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-687" data-mp="5grd8fabz5nx">
              <div className="text-teal-600 mb-4" data-id="element-688" data-mp="ejtv4n68nbk">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-689" data-mp="hxw8cvu4wj0">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10" data-id="element-690" data-mp="3dw17j17zb6l5"></path>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-3 text-teal-800" data-id="element-691" data-mp="38xhpvd0f4gyl">
                Clean Formulas
              </h3>
              <p className="text-gray-700" data-id="element-692" data-mp="1kbr9alv14mj5">
                Free from artificial fillers, allergens, and unnecessary
                additives.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Call to Action */}
      <div className="py-16 bg-teal-800 text-white" data-id="element-693" data-mp="1tdqpxd24tolk">
        <div className="container mx-auto px-4 max-w-7xl" data-id="element-694" data-mp="1yba4yf6nm5ek">
          <div className="max-w-3xl mx-auto text-center" data-id="element-695" data-mp="1yaqypvqd95gd">
            <h2 className="text-3xl font-bold mb-4" data-id="element-696" data-mp="10ojhnmcvlkn4">
              Find Your Microbiome Solution
            </h2>
            <p className="text-xl mb-8 text-teal-100" data-id="element-697" data-mp="15nwff25acc4h">
              Our science team has developed targeted formulas for specific
              health goals.
            </p>
            <div className="flex flex-wrap gap-4 justify-center" data-id="element-698" data-mp="1fd692mfs22up">
              <button className="bg-white text-teal-800 hover:bg-teal-50 transition-colors duration-300 px-6 py-3 rounded-md font-medium" data-id="element-699" data-mp="1fehboixhl4k8">
                Shop All Products
              </button>
              <button className="bg-transparent border border-white text-white hover:bg-white/10 transition-colors duration-300 px-6 py-3 rounded-md font-medium" data-id="element-700" data-mp="muad1ko7xsl2">
                Take Our Gut Health Quiz
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer data-id="element-701" data-mp="2ycncfspng4jt" />
    </div>;
};
export default ProductsPage;